var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "72px",
    viewBox: "0 0 74 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "903E4FF8-5750-40DD-A9CB-55E7FF66E183") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M59.2405235,18.2778943 L54.4464455,12.8358618 L36.708357,32.7279805 L21.4121882,16.3618828 L4.55131402,36 L0,30.8299692 L21.4121882,6.54582426 L36.708357,22.9079219 L49.8951315,7.66583095 L45.0990135,2.22379848 L59.0079597,0.0237853497 C60.319701,-0.184215891 61.364198,0.999791173 61.178555,2.48780005 L59.2405235,18.2778943 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-Page-Builder-v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.1-WebPageBuilder-EmptyWidgets",
    transform: "translate(-478.000000, -322.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line",
    transform: "translate(336.000000, 152.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(30.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Builder/Line-Chart/40dp",
    transform: "translate(112.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Purple",
    transform: "translate(5.400000, 16.200000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Light",
    mask: "url(#mask-2)",
    fill: "#E5E5E5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.400000, -16.200000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 115.2,
    height: 115.2
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChart);
export default __webpack_public_path__ + "static/media/lineChart.10c25ecf57d2786ca5ff3da79e63abc4.svg";
export { ForwardRef as ReactComponent };